module.exports = __webpack_public_path__ + "img/icon-close.34d15c59.svg";